import { render, staticRenderFns } from "./ClientVisits.vue?vue&type=template&id=50862a62&"
import script from "./ClientVisits.vue?vue&type=script&lang=ts&"
export * from "./ClientVisits.vue?vue&type=script&lang=ts&"
import style0 from "./ClientVisits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports